import { render, staticRenderFns } from "./program.vue?vue&type=template&id=aa3071b8&scoped=true&"
import script from "./program.vue?vue&type=script&lang=js&"
export * from "./program.vue?vue&type=script&lang=js&"
import style0 from "./program.vue?vue&type=style&index=0&id=aa3071b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa3071b8",
  null
  
)

export default component.exports